/**
 * Maps Convex auth-action error codes to i18n keys.
 * Convex throws errors as `Error("code")` — the message text is the code.
 */

const KNOWN: Record<string, string> = {
  invalidEmail: "errors.invalidEmail",
  weakPassword: "errors.weakPassword",
  invalidCredentials: "errors.invalidCredentials",
  emailInUseGoogle: "errors.emailInUseGoogle",
  emailInUseApple: "errors.emailInUseApple",
  emailInUseTelegram: "errors.emailInUseTelegram",
  emailInUsePassword: "errors.emailInUsePassword",
  otpNotFound: "errors.otpNotFound",
  otpExpired: "errors.otpExpired",
  otpWrong: "errors.otpWrong",
  otpLocked: "errors.otpLocked",
  resetLinkInvalid: "errors.resetLinkInvalid",
  resetLinkUsed: "errors.resetLinkUsed",
  resetLinkExpired: "errors.resetLinkExpired",
};

export function errorCode(err: unknown): string {
  if (!err) return "errors.generic";
  const raw = err instanceof Error ? err.message : String(err);
  // Convex wraps errors as "Uncaught Error: emailInUseGoogle\n  at handler..."
  for (const code of Object.keys(KNOWN)) {
    if (raw.includes(code)) return KNOWN[code];
  }
  return "errors.generic";
}
